var _defs, _g, _g2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStationPinCngLng(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.39 36.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #006c32;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #9aca3d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.37,12.81c0-5.89-4.78-10.67-10.67-10.67S2.03,6.92,2.03,12.81c0,1.94.52,3.77,1.43,5.33h0l4.62,8,4.62,8,4.62-8,4.62-8h0c.91-1.57,1.43-3.39,1.43-5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.7,35.15L3.02,18.39c-.98-1.7-1.5-3.63-1.5-5.58C1.53,6.65,6.54,1.64,12.7,1.64s11.17,5.01,11.17,11.17c0,1.96-.52,3.89-1.5,5.58l-9.67,16.75ZM12.7,2.64C7.09,2.64,2.53,7.2,2.53,12.81c0,1.78.47,3.54,1.36,5.08l8.81,15.25,8.81-15.25c.89-1.54,1.36-3.3,1.36-5.08,0-5.61-4.56-10.17-10.17-10.17Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.59,34.15l4.62-8,4.62-8h0c.91-1.57,1.43-3.39,1.43-5.33,0-5.89-4.78-10.67-10.67-10.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.02,34.4l-.87-.5,9.24-16c.89-1.54,1.36-3.3,1.36-5.08,0-5.61-4.56-10.17-10.17-10.17v-1c6.16,0,11.17,5.01,11.17,11.17,0,1.96-.52,3.89-1.5,5.58l-9.24,16Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12.7,
    cy: 12.48,
    r: 4.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationPinCngLng);
export default __webpack_public_path__ + "static/media/Station_Pin__CNG_LNG.17e434cb84c7555f07be3d419adfc479.svg";
export { ForwardRef as ReactComponent };